import Vue from 'vue'
import Vuex from 'vuex'
import { setToken, removeToken, getToken } from '@/libs/cookieUtil'

Vue.use(Vuex)

const state = {
  token: '',
  accountInfo: '',
  showUser: false
}

const mutations = {
  updateToken (state, iRet) {
    state.token = iRet;
    setToken(iRet);
  },
  updateAccountInfo (state, content) {
    state.accountInfo = content;
  }
}

const actions = {
  logout (state) {
    return new Promise((resolve, reject) => {
      removeToken();
      resolve(true);
    })
  }
}

export default new Vuex.Store({
  state,
  mutations,
  actions
})



// WEBPACK FOOTER //
// ./src/store/index.js